import React from "react";
import { Edit } from "@mui/icons-material";

import { LayerGroupIds } from "fond/layers";
import { beginEditing } from "fond/project/redux";
import { useAppDispatch } from "fond/utils/hooks";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

const ModificationsPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const { open } = useStackedNavigationContext();

  const handleOnEdit = (mode: keyof typeof LayerGroupIds) => () => {
    dispatch(beginEditing(mode));
    open(`modification-${mode}`);
  };

  return (
    <>
      <StackedNavigationButton icon={<Edit />} title="Edit Lead-Ins" onClick={handleOnEdit("inLeadIns")} />
      <StackedNavigationButton icon={<Edit />} title="Edit Underground" onClick={handleOnEdit("inUnderground")} />
    </>
  );
};

export default ModificationsPanel;
